skrilla.directive('skrillaTable', function () {
    return {
        templateUrl: 'directives/skrillaTable/skrillaTable.html',
        scope: {
            data: "=",
            selectedRows: "=" //the output of rows selected with checkboxes
        },
        controller: function ($scope, cacheService, modalService, valuesToWordsService, $filter, currencyService, _) {
            var currencies = currencyService.getCurrencies()
            $scope.showCheckBoxes = $scope.selectedRows !== undefined;

            $scope.checked = function(row){
                //Don't use .filter so we don't create a new object
                const index = $scope.selectedRows.indexOf(row);
                if (index > -1) {
                    $scope.selectedRows.splice(index, 1);
                }
                else{
                    $scope.selectedRows.push(row);
                }
            };

            $scope.clickRow = function(row, event){
                if($scope.data.rows.onClick){
                    $scope.data.rows.onClick(row, event);
                }
            }
            $scope.clickField = function (row, field, event) {
                if(field.onClick){
                    event.stopPropagation();
                    field.onClick(row, field, event);
                }
            }

            $scope.getTags = function(row, column){
                return row[column.tags];
            }

            $scope.presentData = function(row, column){
                const filter = column.filter;
                const fieldValue =  _.get(row, column.field);
                if(filter){
                    if (filter.name) {
                        const args = [fieldValue].concat(getFilterArgs(row, filter));
                        return $filter(filter.name).apply(fieldValue, args)
                    } else if (filter.func) {
                        return filter.func(fieldValue)
                    }
                }
                else{
                    return fieldValue;
                }
            }

            function getFilterArgs(row, filter){
                if (!filter.args) return [];

                var args = Array.from(filter.args);
                if(filter.name === "dollarOrSkrilla"){
                    if(filter.args[0] && !currencies.includes(filter.args[0])){
                        //check to see if we've been passed a currency field
                        if(row[filter.args[0]] &&  currencies.includes(row[filter.args[0]])){
                            args[0] = row[filter.args[0]];
                        }
                    }
                }
                return args;
            }

        }
    };
});
